import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { getCurrentEnvironment } from './utils/environment-urls.ts';
const enviroment = getCurrentEnvironment();

const appVersion = '1.0.0';

Bugsnag.start({
  apiKey: '87ca39907f1f21d5f03206af55c9cf4b',
  appVersion: appVersion,
  enabledReleaseStages: enviroment === 'production' ? ['production'] : [],
  plugins: [new BugsnagPluginReact()]
})

if (enviroment === 'production') {
  BugsnagPerformance.start({ 
    apiKey: '87ca39907f1f21d5f03206af55c9cf4b',
    appVersion: appVersion
  })
}

createRoot(document.getElementById("root")!).render(<App />);
